import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
const FormItem = Form.Item;

class RegistrationForm extends React.Component {
    render() {
        const { visible, onCancel, onCreate, form } = this.props;
        const { getFieldDecorator } = form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        return (
            <Modal
                visible={visible}
                title="Create new admin user"
                okText="Create"
                onCancel={onCancel}
                onOk={onCreate}
            >
                <Form>
                    <FormItem hasFeedback
                              {...formItemLayout}
                              label="name"
                    >
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: 'Please input your name!', whitespace: true }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem hasFeedback
                              {...formItemLayout}
                              label="Address Line 1"
                    >
                        {getFieldDecorator('address_line_1', {
                            rules: [{ required: true, message: 'Please input your address line 1', whitespace: true }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem hasFeedback
                              {...formItemLayout}
                              label="Address Line 1"
                    >
                        {getFieldDecorator('address_line_2', {
                            rules: [{ required: true, message: 'Please input your address line 2', whitespace: true }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem hasFeedback
                              {...formItemLayout}
                              label="Address Line 3"
                    >
                        {getFieldDecorator('address_line_3', {
                            rules: [{ required: false, message: 'Please input your address line 3', whitespace: true }],
                        })(
                            <Input />
                        )}
                    </FormItem>

                    <FormItem hasFeedback
                              {...formItemLayout}
                              label="Post Code"
                    >
                        {getFieldDecorator('post_code', {
                            rules: [{ required: true, message: 'Please input your post code', whitespace: true }],
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="Phone Number"
                    >
                        {getFieldDecorator('phone', {
                            rules: [{ required: true, message: 'Please input your phone number!' }],
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="E-mail"
                    >
                        {getFieldDecorator('email', {
                            rules: [{
                                type: 'email', message: 'The input is not valid E-mail!',
                            }, {
                                required: true, message: 'Please input your E-mail!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
};

const WrappedForm = Form.create()(RegistrationForm);

class NewUser extends React.Component {
    onOk() {
        const form = this.formRef.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            console.log('Received values of form: ', values);
            form.resetFields();
            this.setState({ visible: false });
        });
    }
    onCancel() {
        this.props.onCancel();
    }
    saveFormRef(formRef) {
        this.formRef = formRef;
    }
    render() {
        return (
            <WrappedForm
                wrappedComponentRef={this.saveFormRef.bind(this)}
                visible={this.props.visible}
                onCancel={this.onCancel.bind(this)}
                onCreate={this.onOk.bind(this)}
            />
        );
    }
};

export default NewUser;


// WEBPACK FOOTER //
// ./resources/assets/js/components/NewUser.js